import { AccountingPurchaser, AccountingPurchaserProps } from "./AccountingPurchaser";
import { AccountingJournalEntryLine, AccountingJournalEntryLineProps } from "./AccountingJournalEntryLine";
import { DateAdapter } from "@/infrastructure/adapters/dayJs/DayJs.adapter";
import { DateService } from "@/core/services";

export interface AccountingJournalEntryProps {
  remittanceId: number;
  checkNumber: string;
  checkDate: string;
  jeTotal: number;
  purchaser: AccountingPurchaserProps;
  journalEntryLines: AccountingJournalEntryLineProps[];
}

export class AccountingJournalEntry {
  private readonly _remittanceId: number;
  private readonly _checkNumber: string;
  private readonly _checkDate: string;
  private readonly _jeTotal: number;
  private readonly _purchaser: AccountingPurchaser;
  private readonly _journalEntryLines: AccountingJournalEntryLine[];

  constructor(props: AccountingJournalEntryProps) {
    this._remittanceId = props.remittanceId;
    this._checkNumber = props.checkNumber;
    this._checkDate = props.checkDate;
    this._jeTotal = Number(props.jeTotal ?? 0);
    this._purchaser = AccountingPurchaser.fromJson(props.purchaser);
    this._journalEntryLines = (props.journalEntryLines ?? []).map(line => AccountingJournalEntryLine.fromJson(line));
  }

  public get key(): number {
    return this._remittanceId;
  }

  public get remittanceId(): number {
    return this._remittanceId;
  }

  public get checkNumber(): string {
    return this._checkNumber;
  }

  public get checkDate(): string {
    return this._checkDate;
  }

  public get jeTotal(): number {
    return this._jeTotal;
  }

  public get purchaser(): AccountingPurchaser {
    return this._purchaser;
  }

  public get journalEntryLines(): AccountingJournalEntryLine[] {
    return this._journalEntryLines;
  }

  public static fromJson(props: AccountingJournalEntryProps): AccountingJournalEntry {
    return new AccountingJournalEntry(props);
  }

  public checkDateFormatted(format: string): string {
    if (!this._checkDate) return "-";
    return new DateService(new DateAdapter()).format(this._checkDate, format);
  }
  
}
